<template>
  <div class="oss-list page-box">
    <div class="page-content">
      <div class="content-header">
<!--        另外新搞一个界面 todo-->
<!--        <vs-button
          v-if="isAdmin"
          class="sear
          ch-btn btn box-item"
          @click="configHandle"
        >云存储配置</vs-button>-->
        <vs-button
          v-if="isAuth('sys:oss:file:upload')"
          class="add-btn btn box-item"
        >
          <oss-uploader
            @uploaded="uploadedSuccess"
          ></oss-uploader>
        </vs-button>
        <vs-button
          v-if="isAuth('sys:role:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn"
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              URL地址
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                <img
                  class="image-sm"
                  v-if="isImageUrl(tr.url)"
                  :src="tr.url"
                />
                <a
                  :href="tr.url"
                  target="_blank"
                  v-else
                >{{tr.url}}</a>
              </vs-td>
              <vs-td>
                {{parseTime(tr.createDate)}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('sys:oss:file:delete')"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <oss-config-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></oss-config-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import ossUploader from '@/components/public/ossUploader'
import ossConfigDialog from "@/components/oss/ossConfigDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import {deleteOss} from "@/api/oss/oss";
export default {
  name: "index",
  components: {
    ossConfigDialog,
    ossUploader,
    multipleDeleteDialog,
  },
  data() {
    return {
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
    isAdmin(){
      return localStorage.getItem('userName') == 'admin';
    }
  },
  created(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/oss/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order': 'desc'
      }
      return true;
    },
    isImageUrl(url) {
      return url && /.*\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)/.test(url)
    },
    uploadedSuccess(){
      this.searchHandle();
    },
    configHandle(){
      this.addDialogShow =true;
    },

    addHandle(){
      this.addDialogShow = true;
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    deleteHandle(row){
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteOss(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.oss-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
